import { SrfSrgLogin } from '@aron/srg-login/SrfSrgLogin';
import { getConfig } from '@fec/assets/js/utils/config';

// @ts-ignore
const { SRG_LOGIN: config, BUSINESS_UNIT: bu } = getConfig();

export function init() {
  if (!config) {
    return;
  }

  new SrfSrgLogin(config.authority, config.clientId, config.scopes, bu);
}
